import { render, staticRenderFns } from "./GiveawaysCard.vue?vue&type=template&id=284675eb&"
import script from "./GiveawaysCard.vue?vue&type=script&lang=js&"
export * from "./GiveawaysCard.vue?vue&type=script&lang=js&"
import style0 from "./GiveawaysCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports